export default __webpack_public_path__ + "static/media/welcome_red.bcf55c93.gif";